<script>
  import Icon from '@/components/Icon';
  import Percent from '@/components/Percent';
  import ArrowRight from '@/assets/arrow-right.svg';
  import WalletWind from '@/assets/wallet-wind.svg';
  import WalletDonut from '@/components/Wallet/Donut';
  import WalletCircle from '@/assets/wallet-circle.svg';
  import { mapGetters, mapState, mapMutations } from 'vuex';
  import WalletArrowRed from '@/assets/wallet-arrow-red.svg';
  import WalletArrowGreen from '@/assets/wallet-arrow-green.svg';

  export default {
    components: {
      Icon,
      Percent,
      ArrowRight,
      WalletWind,
      WalletDonut,
      WalletCircle,
      WalletArrowRed,
      WalletArrowGreen,
    },

    computed: {
      ...mapState('coins', [
        'coins',
      ]),

      ...mapGetters('coins', [
        'coin',
      ]),

      ...mapState('transaction', [
        'list',
      ]),
    },

    methods: {
      ...mapMutations('coins', [
        'SET_ACTIVE',
      ]),
    },
  };
</script>

<template>
  <main class="wallet container container--padding">
    <div class="row">
      <article class="col--4 card">
        <header class="card__header">
          <h1 class="card__title">Carteira</h1>
        </header>

        <WalletDonut class="wallet__donut" />

        <section class="wallet-coins">
          <div
            :key="initial"
            class="wallet-coins__item"
            @click.prevent="SET_ACTIVE(initial)"
            v-for="({ initial, title, formated, color }) in coins"
            :class="{ 'wallet-coins__item--active': initial === coin.initial }"
            >
            <Icon class="wallet-coins__item-icon" :icon="title" />

            <div class="wallet-coins__item-content">
              <h2 :style="{ color }" class="wallet-coins__title">{{ initial }} (R$)</h2>
              <p class="wallet-coins__item-total" v-text="formated"></p>

              <div class="wallet-coins__item-actions">
                <RouterLink
                  to="/carteira/enviar"
                  class="wallet-coins__item-action"
                  >
                  Enviar
                </RouterLink>

                <RouterLink
                  to="/carteira/receber"
                  class="wallet-coins__item-action"
                  >
                  Receber
                </RouterLink>
              </div>
            </div>

            <ArrowRight
              class="wallet-coins__item-arrow"
              />
          </div>
        </section>
      </article>

      <article class="col--8 card">
        <header class="card__header">
          <h1 class="card__title">Entrada e saída de {{ coin.title }}</h1>
        </header>

        <div class="card__body">
          <div class="wallet-orders__header">
            <div class="wallet-orders__header-content">
              <h2 class="wallet-orders__header-title" v-text="coin.title"></h2>
              <span class="wallet-orders__header-quantity">0,43498355</span>
              <WalletWind class="wallet-orders__header-icon" />{{ coin.formated }}
            </div>

            <RouterLink
              to="/carteira/enviar"
              class="wallet-orders__header-action"
              >
              Enviar
            </RouterLink>

            <RouterLink
              to="/carteira/receber"
              class="wallet-orders__header-action"
              >
              Receber
            </RouterLink>
          </div>

          <ul class="wallet-orders">
            <RouterLink
              append
              tag="li"
              :key="id"
              :to="id.toString()"
              class="wallet-orders__item"
              v-for="({ id, quantity, type, percent }) in list"
              >
              <span class="wallet-orders__icon">
                <Component :is="type == 'sent' ? 'WalletArrowRed' : 'WalletArrowGreen'" />
              </span>

              <div class="wallet-orders__content">
                <p class="wallet-orders__title">
                  {{ type === 'sent' ? 'Envio de ' : 'Recebimento de ' }}{{ coin.title }}
                  <span class="wallet-orders__quantity">{{ quantity > 0 ? `+${quantity}` : quantity }} {{ coin.initial }}</span>
                </p>

                <p class="wallet-orders__about">
                  <span
                    class="wallet-orders__action"
                    >
                    <WalletCircle class="wallet-orders__circle" />
                    {{ type == 'sent' ? 'Enviado' : 'Recebido' }}
                  </span>

                  <Percent
                    :value="percent"
                    class="wallet-orders__percent"
                    />
                </p>
              </div>
            </RouterLink>
          </ul>
        </div>
      </article>
    </div>

    <!-- modal -->
    <transition name="fade">
      <RouterView />
    </transition>
  </main>
</template>

<style lang="scss">
  .wallet {
    &__donut {
      padding: 8px 0;
      margin-bottom: 16px;
      justify-content: center;
    }

    &-coins {
      display: flex;
      flex-direction: column;
      background-color: rgba(#FFF, .08);

      &__item {
        display: flex;
        cursor: pointer;
        padding: 13px 24px;

        &:hover {
          background-color: rgba(#161831, .8);
        }

        &:not(:last-of-type) {
          border-bottom: 1px solid rgba(#939cac, .38);
        }

        &--active {
          border-left: 3px solid #FFF;
          background-color: rgba(#14162f, .9) !important;
        }

        &--active & {
          &-action {
            color: #FFF;
          }
        }

        &-icon {
          width: 40px;
          height: 43px;
          margin-right: 16px;
        }

        &-title {
          letter-spacing: 0.32px;
        }

        &-total {
          color: #FFF;
          font-size: 20px;
          margin-bottom: 18px;
          letter-spacing: 0.4px;
        }

        &-actions {
          display: flex;
        }

        &-action {
          font-size: 13px;
          color: #b2b8c5;
          margin-right: 24px;
          letter-spacing: 0.26px;
        }

        &-arrow {
          color: #979797;
          margin-left: auto;
          align-self: center;
        }
      }
    }

    &-orders {
      &__header {
        color: #FFF;
        display: flex;
        font-size: 20px;
        margin-bottom: 32px;

        &-title {
          line-height: 1;
          font-size: 32px;
          margin-bottom: 10px;
        }

        &-quantity {
          color: #b2b8c5;
        }

        &-icon {
          margin: 0 12px;
        }

        &-action {
          color: #FFF;
          font-size: 16px;
          padding: 12px 20px;
          border-radius: 4px;
          align-self: flex-start;
          letter-spacing: 0.86px;
          border: solid 1px #ffffff;

          &:hover {
            background-color: rgba(#FFF, 0.1);
          }

          &:first-of-type {
            margin-left: auto;
          }

          &:not(:first-of-type) {
            margin-left: 16px;
          }
        }
      }

      &__item {
        display: flex;
        cursor: pointer;
        padding: 16px 0;
        align-items: center;

        &:not(:last-of-type) {
          border-bottom: 1px solid rgba(#939cac, .15);
        }
      }

      &__icon {
        width: 32px;
        height: 32px;
        display: flex;
        margin-right: 16px;
        border-radius: 50px;
        align-items: center;
        justify-content: center;
        background-color: rgba(#FFF, .08);
      }

      &__content {
        flex: 1;
      }

      &__title {
        display: flex;
        color: #ffffff;
        line-height: 1.25;
        margin-bottom: 9px;
        justify-content: space-between;
      }

      &__quantity {
        font-weight: 300;
      }

      &__about {
        display: flex;
        align-items: flex-end;
      }

      &__circle {
        margin-right: 2px;
      }

      &__action {
        font-size: 14px;
        color: #b2b8c5;
        line-height: 1.43;
      }

      &__percent {
        margin-left: auto;
      }
    }
  }
</style>
